import { numberToPrettyString } from '@cian/utils';
import { IOfferCard } from '../../../types';

export function getSalePricePerMeter(offerCard: IOfferCard): string | null {
  if (!offerCard.bargainTerms) {
    return null;
  }

  if (offerCard.category && offerCard.category.includes('room') && offerCard.roomArea) {
    const pricePerMeter = Math.floor(offerCard.bargainTerms.priceRur / Number(offerCard.roomArea));

    return `${numberToPrettyString(pricePerMeter)}\u00A0₽/м²`;
  }

  if (offerCard.bargainTerms.priceType !== 'all') {
    return `${numberToPrettyString(offerCard.bargainTerms.priceRur)}\u00A0₽`;
  } else if (offerCard.totalArea) {
    const totalArea = parseFloat(offerCard.totalArea);

    if (totalArea > 0) {
      const pricePerMeter = Math.round(offerCard.bargainTerms.priceRur / totalArea);
      const pricePerMeterFormatted = numberToPrettyString(pricePerMeter);

      return `${pricePerMeterFormatted}\u00A0₽/м²`;
    }
  }

  return null;
}
